import React, { useState, useEffect } from 'react';
import './Navbar.css';

const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Sales', href: '#sales' },
  { label: 'AMC', href: '#amc' },
  { label: 'Contact', href: '#contact' },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);

      // Highlight active nav link
      const sections = navLinks.map(l => l.href.replace('#', ''));
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && window.scrollY >= el.offsetTop - 100) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav className={`ats-navbar navbar navbar-expand-lg ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        {/* Brand */}
        <a className="navbar-brand ats-brand" href="#home" onClick={e => handleNavClick(e, '#home')}>
          {/* <span className="brand-ats">ATS</span> */}
           <img src="/ATS.jpeg" alt="ATS Logo" className="nav-logo" />
          <span className="brand-full"> AIR TECHNO SERVICES</span>
        </a>

        {/* Mobile toggle */}
        <button
          className={`ats-toggler ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Links */}
        <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`}>
          <ul className="navbar-nav ms-auto gap-lg-2">
            {navLinks.map(link => (
              <li className="nav-item" key={link.label}>
                <a
                  className={`nav-link ats-nav-link ${activeSection === link.href.replace('#', '') ? 'active' : ''}`}
                  href={link.href}
                  onClick={e => handleNavClick(e, link.href)}
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="nav-item ms-lg-3">
              <a
                className="btn-ats-primary btn-sm-nav"
                href="#contact"
                onClick={e => handleNavClick(e, '#contact')}
              >
                Get a Quote
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
